<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
			<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Acción problémica">
				<div class="container-fluid">
					<div class="row" id="slide-1">
						<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
							<div class="p-3 pl-lg-5">
								<h2 class="mt-5">Acción problémica</h2>
								<h3>Mi hipótesis sobre la adquisición del lenguaje</h3>
								<h5>Tipo de actividad: tarea</h5>
								<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
								<p>Analizar las actitudes y opiniones que existen sobre los procesos de adquisición del lenguaje.</p>
								<h4 class="mt-3">Planteamiento</h4>
								<p>Realice una breve encuesta a cinco personas que incluya las siguientes preguntas:</p>
								<div class="row">
									<div class="col-12 d-flex">
										<span class="numeracionMorada1 mr-2">1</span>
										<p>¿Cómo cree que los niños y niñas adquieren el lenguaje?</p>
									</div>
									<div class="col-12 d-flex">
										<span class="numeracionMorada1 mr-2">2</span>
										<p>¿Qué es primero, el lenguaje o el pensamiento?</p>
									</div>
									<div class="col-12 d-flex">
										<span class="numeracionMorada1 mr-2">3</span>
										<p>¿Cómo aprenden el significado de las cosas los niños y las niñas?</p>
									</div>
								</div>
								<p>Sobre este ejercicio, realice el procedimiento presentado a continuación:</p>
								<ul class="bulletMorado ml-4">
									<li class="bulletMorado">Haga un cuadro comparativo donde diferencie cada una de las respuestas por pregunta y persona.</li>
									<li class="bulletMorado">Identifique si hay un patrón en las respuestas.</li>
									<li class="bulletMorado">Describa cuáles son las actitudes y opiniones que tienen los entrevistados sobre las preguntas hechas.</li>
									<li class="bulletMorado">Contraste las respuestas con su punto de vista sobre las preguntas.</li>
								</ul>
								<p class="mb-5">Explique los hallazgos del ejercicio en un texto argumentativo elaborado con letra Times New Roman a 12 puntos, interlineado 1.5 y cuya extensión no supere una cuartilla de texto.</p>
							</div>
						</div>
						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AP justify-content-center align-items-center"> 
							<p class="RefimgActiv">Foto por Pixabay en <a href="https://www.pexels.com/es-es/foto/adentro-adulto-aprender-aprendiendo-261909/" target="_blank" class="text-white">Pexels</a></p>
							<div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
								<div class="row ml-xl-3 ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100">
									<div class="col-lg-12 col-md-12 col-12 p-lg-5 p-3 d-flex align-items-center justify-content-center">	
											<button class="btn BtnPrincipal" onClick="javascript:window.open('http://campusvirtual.itm.edu.co/mod/assign/view.php?id=204013', '_blank');">Subir archivo</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'AccionProblemica',

      mounted() {
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>